import styled from 'styled-components';

const BulletList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : 0)};
`;

export default BulletList;
